import { WaybillIdView } from '../../../../models';

export class ShipmentWaybillStatusHistoryLoad {
  public static readonly type = '[ShipmentWaybillStatusHistory] Load Status History';
  constructor(public payload: WaybillIdView) {}
}

export class ShipmentWaybillStatusHistorySetInitialState {
  public static readonly type = '[ShipmentWaybillStatusHistory] Set Initial State';
}
